/**
 * 错误类型
 */
export const ERRORTYPES = {
  JAVASCRIPT_ERROR: "JAVASCRIPT_ERROR",
  LOG_ERROR: "LOG_ERROR",
  FETCH_ERROR: "HTTP_ERROR",
  VUE_ERROR: "VUE_ERROR",
  RESOURCE_ERROR: "RESOURCE_ERROR",
  PROMISE_ERROR: "PROMISE_ERROR",
};

/**
 * 事件类型
 */
export const EVENTTYPES = {
  XHR: "xhr",
  FETCH: "fetch",
  ERROR: "error",
  UNHANDLEDREJECTION: "unhandledrejection",
  RESOURCE: "resource",
  VUE: "vue",
  PERFORMANCE: "performance",
  BUSINESS: "business",
};

export const RESOURCEMAP = {
  img: "图片",
  script: "js脚本",
};

/**
 * 性能类型
 */
export const PERFORMANCETYPE = {
  FP: "首屏加载时间",
  FCP: "首次内容绘制",
  LCP: "首屏时间 / 最大内容绘制",
  TTFB: "首字节达到时间",
  FID: "首次输入延迟",
  CLS: "累积布局偏移",
};
